import PropTypes from 'prop-types';
import { set, sub } from 'date-fns';
import { noCase } from 'change-case';
import { faker } from '@faker-js/faker';
import { useEffect, useState } from 'react';
// @mui
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  Popover,
  Typography,
  IconButton,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
} from '@mui/material';
// utils
import { fToNow } from '../../../utils/formatTime';
// components
import Iconify from '../../../components/iconify';
import Scrollbar from '../../../components/scrollbar';
import { GetMyAlerts, MarkAsAllRead, MarkAsReadSpecific } from 'src/components/services/httpServices';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const NOTIFICATIONS = [
  {
    id: faker.datatype.uuid(),
    title: 'Your order is placed',
    description: 'waiting for shipping',
    avatar: null,
    type: 'order_placed',
    createdDate: set(new Date(), { hours: 10, minutes: 30 }),
    cleared: true,
  },
  {
    id: faker.datatype.uuid(),
    title: faker.name.fullName(),
    description: 'answered to your comment on the Minimal',
    avatar: '/assets/images/avatars/avatar_2.jpg',
    type: 'friend_interactive',
    createdDate: sub(new Date(), { hours: 3, minutes: 30 }),
    cleared: true,
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new message',
    description: '5 unread messages',
    avatar: null,
    type: 'chat_message',
    createdDate: sub(new Date(), { days: 1, hours: 3, minutes: 30 }),
    cleared: false,
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new mail',
    description: 'sent from Guido Padberg',
    avatar: null,
    type: 'mail',
    createdDate: sub(new Date(), { days: 2, hours: 3, minutes: 30 }),
    cleared: false,
  },
  {
    id: faker.datatype.uuid(),
    title: 'Delivery processing',
    description: 'Your order is being shipped',
    avatar: null,
    type: 'order_shipped',
    createdDate: sub(new Date(), { days: 3, hours: 3, minutes: 30 }),
    cleared: false,
  },
];

export default function NotificationsPopover() {
  const [notifications, setNotifications] = useState(NOTIFICATIONS);
  const [alerts, setAlerts] = useState([]);

  const fetchAlerts = async (event) => {
    const alerts = await GetMyAlerts();
    alerts.reverse();
    setAlerts(alerts);
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  const totalUnRead = alerts?.filter((item) => item.cleared === false).length;

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleMarkAllAsRead = () => {
    setAlerts(
      alerts.map((notification) => ({
        ...notification,
        cleared: true,
      }))
    );
    MarkAsAllReadAlerts();
  };

  const MarkAsAllReadAlerts = async (event) => {
    const response = await MarkAsAllRead();
    //  console.log('MarkAsAllRead Rsponse:', response);
  };

  const handleNotificationClick = () => {
    //  console.log('Clicked Notification:');
  };
  // console.log('Alerts:', alerts);
  // console.log('notifications:', notifications);
  return (
    <>
      <IconButton color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 40, height: 40 }}>
        <Badge badgeContent={totalUnRead} color="error">
          <Iconify icon="eva:bell-fill" />
        </Badge>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1.5,
            ml: 0.75,
            width: 460,
          },
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Notifications</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              You have {totalUnRead} unread messages
            </Typography>
          </Box>

          {totalUnRead > 0 && (
            <Tooltip title=" Mark all as read">
              <IconButton color="primary" onClick={handleMarkAllAsRead}>
                <Iconify icon="eva:done-all-fill" />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Scrollbar sx={{ height: { xs: 340, sm: 'auto' } }}>
          <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                New
              </ListSubheader>
            }
          >
            {alerts?.map((notification) => (
              <NotificationItem
                setOpen={setOpen}
                onClick={handleNotificationClick}
                key={notification.id}
                notification={notification}
              />
            ))}
          </List>

          {/* <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                Before that
              </ListSubheader>
            }
          >
            {alerts?.slice(0, 2).map((notification) => (
              <NotificationItem onClick={handleNotificationClick} key={notification.id} notification={notification} />
            ))}
          </List> */}
        </Scrollbar>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple>
            {/* View All */}
          </Button>
        </Box>
      </Popover>
    </>
  );
}

// ----------------------------------------------------------------------

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    createdDate: PropTypes.instanceOf(Date),
    id: PropTypes.string,
    cleared: PropTypes.bool,
    title: PropTypes.string,
    message: PropTypes.string,
    type: PropTypes.string,
    avatar: PropTypes.any,
  }),
};

function NotificationItem({ notification, setOpen }) {
  const navigate = useNavigate();
  const MarkAsAllReadSpecific = async (id) => {
    const response = await MarkAsReadSpecific(id);
    // console.log('MarkAsReadSpecific Rsponse:', response);
  };
  const handleNotificationClick = () => {
    // console.log('Clicked Notification:', notification);
    if (notification.title === 'Task Completed') {
      navigate(`/app/AssignedTasks`);
    } else if (notification.title === 'Wrongly Assigned') {
      navigate(`/app/AssignedTasks`);
    } else if (notification.title === 'Employer Assigned') {
      navigate(`/app/MyOpportunities`);
    } else if (notification.title === 'Client Assigned') {
      navigate(`/app/MyOpportunities`);
    } else if (notification.title === 'Task Reminder') {
      navigate(`/app/MyTasks`);
    } else if (notification.title === 'Task Assigned') {
      navigate(`/app/MyTasks`);
    } else if (notification.mstClientId != null) {
      navigate(`/app/PerformActivity/${notification.mstClientId}/${true}`);
    } else {
      navigate(`/app/PerformActivity/${notification.mstCompanyId}/${false}`);
    }
    setOpen(null);
    if (notification.cleared != true) {
      MarkAsAllReadSpecific(notification.id);
    }
  };

  const { title, message, avatar } = renderContent(notification);
  // console.log('notification:::::', notification);
  return (
    <ListItemButton
      sx={{
        py: 1.5,
        px: 2.5,
        mt: '1px',
        ...(notification.cleared == true && {
          bgcolor: 'action.selected',
        }),
      }}
      onClick={handleNotificationClick}
    >
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: 'background.neutral' }}>{avatar}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled',
            }}
          >
            <Iconify icon="eva:clock-outline" sx={{ mr: 0.5, width: 16, height: 16 }} />
            {fToNow(notification?.createdDate)}
          </Typography>
        }
      />
    </ListItemButton>
  );
}

// ----------------------------------------------------------------------

function renderContent(notification) {
  const title = (
    <Typography variant="subtitle2">
      {notification.title}
      {/* {notification.title+notification.id} */}
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
        &nbsp; {noCase(notification.message)}
      </Typography>
    </Typography>
  );

  return {
    // avatar: notification.avatar ? <img alt={notification.title} src={notification.avatar} /> : null,
    avatar: <img alt={notification.title} src="/assets/icons/ic_notification_mail.svg" />,
    title,
  };
}
